<template>
	<b-modal
		:hide-footer="true"
		:title="$t('Família Transferida')"
		centered
		size="xl"
		id="modal-transferida"
	>
		<div class="row">
			<div class="col-md-12">
				<table class="table table-striped">
					<thead>
						<tr>
							<th>Data da transferência : {{ item.transferencia.data_transferencia }}</th>
							<th>Estado Cadastral: {{ item.transferencia.estado_cadastral }}</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<p>Código prefeitura de destino</p>
								<b>{{ item.transferencia.codigo_prefeitura_destino }}</b>
							</td>
							<td>
								Código familiar <b>{{ item.transferencia.codigo_familia_destino }}</b>
							</td>
						</tr>
						<tr>
							<td colspan="2">
								Município de origem da familia: <b>{{ item.transferencia.municipio_origem }}</b>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</b-modal>
</template>
<script>
export default {
	props: ["item"],
	data() {
		return {};
	},
	methods: {
		submit() {},
	},
};
</script>
